<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <span>应用端口</span>
        <el-select
          v-model="platform"
          placeholder="请选择"
          style="width: 150px; margin: 0 20px 0 10px"
          @change="search"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span>页面名称</span>
        <el-input
          v-model="point_name"
          style="width: 150px; margin: 0 10px"
          clearable
          @change="search"
        ></el-input>
        <span>统计时间</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          style="width: 250px; margin: 0 10px"
          @change="search"
        >
        </el-date-picker>

        <el-button
          type="info"
          style="background-color: #eceff2; color: #747981"
          @click="search"
        >查询</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            prop="platform"
            label="应用端口"
          >
          </el-table-column>
          <el-table-column
            prop="buried_point_name"
            label="页面名称"
          >
            <template slot-scope="scope">
              <div>
                {{scope.row.buried_point_name?scope.row.buried_point_name:scope.row.buried_point_code}}
              </div>
            </template>

          </el-table-column>
          <el-table-column
            prop="person_count"
            label="访问人数"
          >
          </el-table-column>
          <el-table-column
            prop="person_stop_time"
            label="人均停留时长（秒）"
          ></el-table-column>

          <el-table-column
            label="打开次数"
            prop="view_count"
          >
          </el-table-column>
          <el-table-column
            label="次均停留时长（秒）"
            prop="view_stop_time"
          >
          </el-table-column>
          <el-table-column
            prop="person_out_rate"
            label="跳出率（人数）"
          ></el-table-column>
          <el-table-column
            prop="view_out_rate"
            label="跳出率（次数）"
          ></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="toDetail(scope.row)"
                type="text"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1028') : false
                "
              >查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      platform: '',
      point_name: '',
      date: [],
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'ios',
          label: 'ios'
        },
        {
          value: 'android',
          label: '安卓'
        },
        {
          value: 'shopapplet',
          label: '商城小程序'
        },
        {
          value: 'applet',
          label: '诊疗小程序'
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        platform: this.platform,
        point_name: this.point_name
      };
      if (this.date && this.date.length) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Buried/buriedPointPageList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //详情
    toDetail(row) {
      this.$router.push({
        path: '/home/shoppingmall/pointdata',
        query: {
          page_id: row.page_id,
          buried_point_name: row.buried_point_name,
          platform: row.platform,
          date: JSON.stringify([
            dayjs(this.date[0]).format('YYYY-MM-DD'),
            dayjs(this.date[1]).format('YYYY-MM-DD')
          ])
        }
      });
    }
  },
  activated() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.date = [start, end];
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 210px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 20px;
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
  }
  .pricebox {
    display: flex;
    align-items: center;
    padding: 15px 0;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 20px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: '';
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      width: 60px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
</style>